import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=a6f70c9a&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a6f70c9a')) {
      api.createRecord('a6f70c9a', component.options)
    } else {
      api.reload('a6f70c9a', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=a6f70c9a&", function () {
      api.rerender('a6f70c9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2vH07teKVUaqW/JS/comp/openstreetmap.vue"
export default component.exports